<template>
	<div class="short-history">
		<div class="default-block-title">
			{{ t.shortHistoryBlockTitle }}
		</div>

		<div v-if="loadingData" class="spinner" style="position: inherit;">
			<loader />
		</div>
		<div v-else>
			<div v-if="items && items.length">
				<div v-for="item in items" :key="item.id" class="item">
					<div class="pull-right">
						<span class="points" :class="{'cost': item.type=='redemption'}">
							{{ item.type=='achievement' && item.points > 0 ? '+' : '' }}{{ item.points }}

							<span v-if="item.type!='redemption' && item.prize_id"><font-awesome-icon icon="gift" /></span>
						</span>
					</div>
					<!-- Don't change title for these types -->
					<div v-if="item.source_type == 'manual_award' || item.source_type == 'points_transfer'">
						<span class="title">{{ getTranslation(item.title) }}</span>
					</div>

					<!-- Otherwise manipulate title -->
					<template v-else>
						<div v-if="item.type=='redemption'" v-html="insertText(t.historyPrizeRedeemed, '<span class=\'title\'>'+ getTranslation(item.title) + '</span>')" />

						<div v-else v-html="insertText(t.historyChallengeCompleted, '<span class=\'title\'>' + getTranslation(item.title) + '</span>')" />
					</template>
					
					<div class="clearfix" />
				</div>

				<router-link :to="{name: 'history'}" class="history-link">
					<font-awesome-icon icon="history" />
					{{ t.shortHistorySeeAllHistory }}
				</router-link>
			</div>
			<div v-else>
				<div class="block-no-items">
					{{ t.myRewardsBlockNoItems }}
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, inject, onMounted, ref } from "vue";
import { getTranslation } from "../../includes/helpers"
import { insertText } from '../../includes/helpers'
import { $on } from "@/js/includes/event-bus";
import { useStore } from '@/js/stores/index';

const axios = inject('axios')
const store = useStore()

// Reactives
const loadingData = ref(true)
const items = ref(false)

// Computeds
const t = computed(() => store.translations)

// Methods
function loadHistory(){
	loadingData.value = true
	
	axios.get('/api/user-side/getUserHistoryLog?length=3')
		.then(({ data }) => items.value = data)
		.finally(() => loadingData.value = false)
}

// Lifecycle
onMounted(() => {
	loadHistory()
})

// Events
$on('achievement-collected', () => {
	loadHistory()
})

$on('reward-created', () => {
	loadHistory()
})

$on('challenge-completed', () => {
	loadHistory()
})
</script>